export function withPayloadType<T>() {
  return (t: T) => ({ payload: t });
}

export function withOptionalPayloadType<T>() {
  return (t?: T) => ({ payload: t });
}
